import { toCsv } from '@/shared/lib/csv';

interface CsvKey {
    rx_key: string;
    tx_key: string | null;
    comment: string | null;
}

const CSV_HEADER = ['rx_key', 'tx_key', 'comment'];

/**
 * Comments are written by pilots and end up in staff spreadsheets, so a leading
 * formula character is defused with `'`. Key columns are left verbatim.
 */
function neutraliseFormula(value: string | null): string | null {
    return value && /^[=+\-@\t\r]/.test(value) ? `'${value}` : value;
}

export function keysToCsv(keys: CsvKey[]): string {
    return toCsv(
        CSV_HEADER,
        keys.map((k) => [k.rx_key, k.tx_key, neutraliseFormula(k.comment)]),
    );
}
